import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import EnvironmentManager from 'Utils/environmentManager';
import { syncBetSlipMinStake } from 'Store/actions';

const useCmsPolling = () => {
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const isPollingActiveRef = useRef(false);

  const startPolling = () => {
    const isEnabled = EnvironmentManager.getMessageText({ key: 'cms_refresh_enabled' }) === 'true';
    const intervalMs = Number(EnvironmentManager.getMessageText({ key: 'cms_refresh_interval' })) || 300000;

    if (!isEnabled) {
      return;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    isPollingActiveRef.current = true;

    intervalRef.current = setInterval(async () => {
      if (isPollingActiveRef.current) {
        try {
          await EnvironmentManager.refreshMessages();
          dispatch(syncBetSlipMinStake());
        } catch (error) {
          console.error('CMS polling hatası:', error);
        }
      }
    }, intervalMs);
  };

  const stopPolling = () => {
    isPollingActiveRef.current = false;
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startPolling();
      } else {
        stopPolling();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (document.visibilityState === 'visible') {
      startPolling();
    }

    return () => {
      stopPolling();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
};

export default useCmsPolling;

